<template>
      <section class="cta-banner text-white text-center py-5" style="background: #343a40;">
  <div class="container">
    <h3 class="mb-3">Ready to power your business?</h3>
    <a href="/contact" class="btn btn-outline-light btn-lg">Get in Touch</a>
  </div>
</section>
</template>